import PropTypes from 'prop-types';
import { StyledContainer, StyledContentWrapper, StyledHeading } from './Heading.styles';
import useScreenSize from '../../core/hooks/useScreenSize';
import { Icon } from '../common/Icons';

function Heading({ icon, title, arrow, type, styling }) {
  const [size] = useScreenSize();

  return (
    <StyledContainer styling={styling}>
      <StyledContentWrapper>
        {icon}
        <StyledHeading as={type} styling={styling}>
          {title}
        </StyledHeading>
      </StyledContentWrapper>
      {arrow && size < 992 && <Icon.ArrowBold aria-hidden />}
    </StyledContainer>
  );
}

Heading.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string,
  arrow: PropTypes.bool,
  type: PropTypes.string,
  styling: PropTypes.string,
};

Heading.defaultProps = {
  icon: null,
  title: 'Insert title',
  arrow: false,
  type: 'h3',
  styling: 'h3',
};

export default Heading;
